import { Endpoint } from '../endpoint';
import { OrgStatusId } from '@business/entities/organization_status';
import { TaskStatusResponse, TaskStatusId } from '@business/entities/task_status';
import { RemoveStatusFormData } from '@modules/settings/SettingsPage/Components/StatusTab/RemoveStatusModal/RemoveStatusModal';

export function fetchTaskStatuses() {
  return Endpoint.get<TaskStatusResponse[]>(`@gc/task-status`);
}

export function fetchTaskStatus(id: TaskStatusId) {
  return Endpoint.get<TaskStatusResponse[]>(`@gc/task-status/${id}`);
}

export function updateTaskStatus(id: TaskStatusId, data: Partial<TaskStatusResponse>) {
  return Endpoint.patch<TaskStatusResponse[]>(`@gc/task-status/${id}`, { data });
}

export function createTaskStatus(data: Partial<TaskStatusResponse>) {
  return Endpoint.post<TaskStatusResponse[]>(`@gc/task-status`, { data });
}

export function deletTaskStatus(id: TaskStatusId) {
  return Endpoint.delete<TaskStatusResponse[]>(`@gc/task-status/${id}`);
}

export function sortTaskStatus(ids: string[]) {
  return Endpoint.post<TaskStatusResponse[]>(`@gc/task-status/sort-task-status`, { data: { ids } });
}
